import React from 'react';

export const Question = ( { children } ) => {
  return (
    <p className="question text-05-navy-blue-bold">{children}</p>
  )
}